import { ListaAgrupamentosDeStatusContrato, ListaAgrupamentosDeStatusPedido, StatusAnaliseCadastral, ListaAgrupamentosDeStatusPagamento } from './constants'
import { StatusBoletoCarrinho } from './multiplasCotasBoletoStatus'
import { StatusAlocacoes, StatusAlocacoesDesc } from './status_alocacoes'

export const colorEmProcesso = 'var(--info)'
export const colorNeutro = 'var(--neutral)'
export const colorSucesso = 'var(--success)'
export const colorAlerta = 'var(--warning)'
export const colorErro = 'var(--error)'

export const colorPastelEmProcesso = '#AFDEFA'
export const colorPastelNeutro = '#efefef'
export const colorPastelSucesso = '#BDF6E3'
export const colorPastelAlerta = '#FBF5C5'
export const colorPastelErro = '#FFD1D0'

export const iconEspera = 'mdi mdi-dots-horizontal'
export const iconRascunho = 'mdi mdi-file-document-edit'
export const iconPagamento = 'mdi mdi-credit-card'
export const iconFinalizado = 'mdi mdi-check-circle'
export const iconPago = 'mdi mdi-cash'
export const iconFalha = 'mdi mdi-close-circle'
export const iconBloqueado = 'mdi mdi-minus-circle'
export const iconLoading = 'rod-loading'
export const iconAssinado = 'mdi mdi-file-sign'
export const iconEsperandoAssinar = 'mdi mdi-account-clock'
export const iconAlocado = 'mdi mdi-file-document-check'
export const iconPendente = 'mdi mdi-clock'

export const estilosStatusPedidoPorNomeExibicao = {
  [ListaAgrupamentosDeStatusPedido.Rascunho]: { color: colorNeutro, colorPastel: colorPastelNeutro, icon: iconRascunho },
  [ListaAgrupamentosDeStatusPedido.AguardandoEnvio]: { color: colorEmProcesso, colorPastel: colorPastelEmProcesso, icon: iconLoading },
  [ListaAgrupamentosDeStatusPedido.Pagamento]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconPagamento },
  [ListaAgrupamentosDeStatusPedido.Finalizado]: { color: colorSucesso, colorPastel: colorPastelSucesso, icon: iconFinalizado },
  [ListaAgrupamentosDeStatusPedido.Bloqueado]: { color: colorErro, colorPastel: colorPastelErro, icon: iconBloqueado },
  [ListaAgrupamentosDeStatusPedido.Falha]: { color: colorErro, colorPastel: colorPastelErro, icon: iconFalha }
}

export const estilosStatusContratoPorNomeExibicao = {
  [ListaAgrupamentosDeStatusContrato.EmEspera]: { color: colorNeutro, colorPastel: colorPastelNeutro, icon: iconEspera },
  [ListaAgrupamentosDeStatusContrato.Pendente]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconEsperandoAssinar },
  [ListaAgrupamentosDeStatusContrato.Negado]: { color: colorErro, colorPastel: colorPastelErro, icon: iconBloqueado },
  [ListaAgrupamentosDeStatusContrato.Assinado]: { color: colorSucesso, colorPastel: colorPastelSucesso, icon: iconAssinado },
  [ListaAgrupamentosDeStatusContrato.Falha]: { color: colorErro, colorPastel: colorPastelErro, icon: iconFalha }
}

export const estilosStatusAnaliseCadastralPorStatus = {
  [StatusAnaliseCadastral.Pendente]: { color: colorNeutro, colorPastel: colorPastelNeutro, icon: iconEspera },
  [StatusAnaliseCadastral.EmAnalise]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconLoading },
  [StatusAnaliseCadastral.Aprovado]: { color: colorSucesso, colorPastel: colorPastelSucesso, icon: iconFinalizado },
  [StatusAnaliseCadastral.Reprovado]: { color: colorErro, colorPastel: colorPastelErro, icon: iconBloqueado },
  [StatusAnaliseCadastral.PendenciaCadastral]: { color: colorEmProcesso, colorPastel: colorPastelEmProcesso, icon: iconPendente }
}

export const estilosStatusAlocacaoPorNomeExibicao = {
  [StatusAlocacoesDesc[StatusAlocacoes.Alocado]]: { color: colorSucesso, colorPastel: colorPastelSucesso, icon: iconAlocado },
  [StatusAlocacoesDesc[StatusAlocacoes.NaoAlocado]]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconLoading },
  [StatusAlocacoesDesc[StatusAlocacoes.FalhaAlocacao]]: { color: colorErro, colorPastel: colorPastelErro, icon: iconFalha },
  [StatusAlocacoesDesc[StatusAlocacoes.Cancelada]]: { color: colorErro, colorPastel: colorPastelErro, icon: iconBloqueado }
}
export const estilosStatusBoletoCarrinhoPorNomeExibicao = {
  [StatusBoletoCarrinho.Pago]: { color: colorSucesso, colorPastel: colorPastelSucesso, icon: iconAlocado },
  [StatusBoletoCarrinho.AguardandoPagamento]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconAlocado },
  [StatusBoletoCarrinho.AguardandoFormaPagamento]: { color: colorAlerta, colorPastel: colorPastelAlerta, icon: iconAlocado },
  [StatusBoletoCarrinho.Falha]: { color: colorErro, colorPastel: colorPastelErro, icon: iconAlocado },
  [StatusBoletoCarrinho.EmGeracao]: { color: colorEmProcesso, colorPastel: colorPastelEmProcesso, icon: iconAlocado },
  [StatusBoletoCarrinho.EmEspera]: { color: colorNeutro, colorPastel: colorPastelNeutro, icon: iconAlocado }
}

export const estilosStatusPagamentoPorStatus = {
  [ListaAgrupamentosDeStatusPagamento.Falha]: {
    icon: iconFalha,
    color: colorErro,
    colorPastel: colorPastelErro
  },
  [ListaAgrupamentosDeStatusPagamento.Realizado]: {
    icon: iconPago,
    color: colorSucesso,
    colorPastel: colorPastelSucesso
  },
  [ListaAgrupamentosDeStatusPagamento.Pendente]: {
    icon: iconLoading,
    color: colorEmProcesso,
    colorPastel: colorPastelEmProcesso
  },
  [ListaAgrupamentosDeStatusPagamento.EmEspera]: {
    icon: iconEspera,
    color: colorNeutro,
    colorPastel: colorPastelNeutro
  }
}
